var $landingSlider = $(".slider-landing");
if ($landingSlider.length) {
    $landingSlider.each(function (index, slider) {
        var $landingSliderContainer = $(".slider", slider),
            landingSlider = new Swiper($landingSliderContainer, {
                slideClass: "slider-slide",
                slideActiveClass: "active",
                wrapperClass: "slider-slides",
                navigation: {
                    nextEl: $(".next", slider),
                    prevEl: $(".prev", slider),
                    disabledClass: "disabled"
                },
                pagination: {
                    el: $(".slider-dots", slider),
                    bulletClass: "slider-dot",
                    bulletActiveClass: "active",
                    hiddenClass: "disabled",
                    clickable: true
                },
                speed: 450,
                longSwipesMs: 400,
                loop: true,
                simulateTouch: true,
                roundLengths: true,
                on: {
                    'init': function () {
                        if (this.slides.length > 1) {
                            $(".slider-dots", slider).addClass("use");
                        }
                    }
                }
            });
    })
}
